import { IAssignmentLogger } from '@eppo/js-client-sdk';
import * as elog from '@reverbdotcom/commons/src/elog';
import {
  EppoRandomizationEvent,
  MParticleEventName,
} from '@reverbdotcom/commons/src/elog/mparticle_types';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

// Define logAssignment so that it logs events to mParticle
export const assignmentLogger: IAssignmentLogger = {
  logAssignment(assignment) {
    try {
      const eventAttributes = mParticleCustomEventAttributes(assignment);
      trackEvent(eventAttributes);
    } catch (error) {
      elog.error('Error logging assignment to mParticle', {
        error: error.message,
        assignment,
      });
    }
  },
};

export function mParticleCustomEventAttributes(assignment): EppoRandomizationEvent {
  return {
    eventName: MParticleEventName.EppoRandomizationEvent,
    experiment: assignment.experiment,
    subject: assignment.subject,
    variation: assignment.variation,
    timestamp: assignment.timestamp,
    featureFlag: assignment.featureFlag,
    allocation: assignment.allocation,
    subjectType: assignment.subjectAttributes.subject_type,
    shippingRegion: assignment.subjectAttributes.shipping_region,
    platform: assignment.subjectAttributes.platform,
    platformVersion: assignment.subjectAttributes.platform_version,
    appVersion: assignment.subjectAttributes.app_version,
    mpid: assignment.subjectAttributes.mpid,
    sessionId: elog.currentSession().ID(),
    deviceId: assignment.subjectAttributes.device_id,
    reverbAdmin: assignment.subjectAttributes.ra,
    email: assignment.subjectAttributes.email,
    sort: assignment.subjectAttributes.sort,
    query: assignment.subjectAttributes.query,
    make: assignment.subjectAttributes.make,
    productType: assignment.subjectAttributes.productType,
    category: assignment.subjectAttributes.category,
    shopSlug: assignment.subjectAttributes.shopSlug,
    brand: assignment.subjectAttributes.brand,
    curatedSetSlug: assignment.subjectAttributes.curatedSetSlug,
    filters: assignment.subjectAttributes.filters,
  };
}
